export const TOTAL_PAINT_DENSITY = "total_paint_density";
export const TOTAL_PAINT_VOLUME = "total_paint_volume";
export const TOTAL_PAINT_VOLUME_L = "total_paint_volume_l";
export const TOTAL_PAINT_MASS = "total_paint_mass";
export const TOTAL_PAINT_MASS_KG = "total_paint_mass_kg";
export const BASE_VOLUME = "base_volume";
export const BASE_MASS = "base_mass";
export const COLORANT_VOLUME = "colorant_volume";
export const COLORANT_MASS = "colorant_mass";
export const BFS_GRADE = "bfs_grade";
export const HBW = "hbw";
export const COLOR_RGB = "color_rgb";
export const COLOR_RGB_HEX = "color_rgb_hex";
export const COLOR_LAB = "color_lab";
export const COLOR_XYZ = "color_xyz";
export const Y_VALUE = "y_value";
export const NOMINAL_VOLUME = "nominal_volume";
export const NOMINAL_MASS = "nominal_mass";
export const MAX_COLORANT_VOLUME = "max_colorant_volume";
export const MAX_COLORANT_MASS = "max_colorant_mass";
export const BASE_DENSITY = "base_density";
export const IS_GRAVIMETRIC = "is_gravimetric";
export const OVERFILL = "overfill";
export const BASE_UFI_CODE = "base_ufi_code";
export const UFI_CODES_TABLE = "ufi_codes_table";
export const COLORANT_UFI_CODES = "colorant_ufi_codes";
export const FORMULA_DATE = "formula_date";
export const FORMULA_DATETIME = "formula_datetime";
export const FORMULA_MORE_INFO = "formula_more_info";
export const FORMULA_MORE_INFO_PRINT = "formula_more_info_print";
export const FORMULA_MORE_INFO_INTERNAL = "formula_more_info_internal";
export const FORMULA_VERIFIED = "formula_verified";
export const BATCH_NUMBERS_TABLE = "batch_numbers_table";
export const COLORANT_BATCH_NUMBERS = "colorant_batch_numbers";

export const FORMULA_DESTINATION_ID_EXTERIOR = 1;
export const FORMULA_DESTINATION_ID_INTERIOR = 2;

export const FORMULA_COLORANT_GROUP_ID_SOLVENT_BASED = 1;
export const FORMULA_COLORANT_GROUP_ID_UNIVERSAL = 2;
export const FORMULA_COLORANT_GROUP_ID_UNIVERSAL_SOLVENT_BASED = 3;
export const FORMULA_COLORANT_GROUP_ID_UNIVERSAL_WATER_BASED = 4;
export const FORMULA_COLORANT_GROUP_ID_WATER_BASED = 5;
export const FORMULA_COLORANT_GROUP_ID_WATER_BASED_SOLVENT_BASED = 6;
